import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { Box } from '../../foundation/Box/index.js';
import { StickyHeaderContainer } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../../foundation/Typography/styled.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function ListSubHeader(props) {
  var children = props.children,
    action = props.action,
    _props$sticky = props.sticky,
    sticky = _props$sticky === void 0 ? false : _props$sticky,
    rest = __rest(props, ["children", "action", "sticky"]);
  return /*#__PURE__*/jsxs(StickyHeaderContainer, _extends({
    $sticky: sticky,
    p: "sm",
    alignItems: "center",
    mx: "sm"
  }, rest, {
    children: [/*#__PURE__*/jsx(Typography, {
      $fontSize: "small",
      $fontWeight: "medium",
      $appearance: "100",
      children: children
    }), action && /*#__PURE__*/jsx(Box, {
      ml: "auto",
      children: action
    })]
  }));
}

export { ListSubHeader };
